<template>
  <div>
    <div v-if="disableForm">
      <div class="custom-search d-flex mb-2">
        <b-button
          v-if="canUpdate"
          class="justify-content-start"
          variant="primary"
          @click="inserirHistorico()"
        >
          Alterar Tipo de Registro
        </b-button>

        <b-button
          v-if="canUpdate"
          class="justify-content-start ml-1"
          variant="primary"
          @click="migrarSocio()"
        >
          Migrar para Sócio
        </b-button>
      </div>
      <div class="custom-search d-flex justify-content-end mb-2">
        <b-badge
          variant="primary"
          style="font-size: 16px"
        >
          Registro Atual: {{ registroAtual }}
        </b-badge>
      </div>
      <b-row>
        <b-col md="12">
          <div class="justify-content-center mb-2">
            <h4>Histórico do Tipo de Registro</h4>
          </div>
        </b-col>
      </b-row>
      <vue-good-table
        title="Teste"
        :columns="columns"
        :rows="listaHistorico"
        :rtl="direction"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      />
    </div>
    <div v-else>
      <validation-observer ref="form">
        <b-form @submit.prevent>
          <b-row>
            <!-- nome -->
            <b-col
              cols="12"
              lg="12"
            >
              <validation-provider
                #default="{ errors }"
                name="descricao"
                rules="required"
              >
                <b-form-group
                  label="Descrição"
                  label-for="v-descricao"
                >
                  <b-form-input
                    id="v-descricao"
                    v-model="TipoRegistroPlace.descricao"
                    :state="errors.length > 0 ? false : null"
                    placeholder="descrição"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- situacaoRegistro -->
            <b-col
              ols="12"
              lg="12"
            >
              <b-form-group
                label="Tipo Registro"
                label-for="v-tipoRegistro"
              >
                <v-select
                  v-model="TipoRegistroPlace.tipoRegistro"
                  :disabled="disableForm"
                  label="nome"
                  :options="comboFiltered"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <ButtonsFormVue
            :permission-insert="canUpdate"
            :permission-edit="false"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import { VueGoodTable } from 'vue-good-table'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    VueGoodTable,
    BBadge,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('dependentAdministrativeModule', {
      fullDependent: state => state.fullDependent,
      comboTypesRegister: state => state.comboTypesRegister,
    }),
    ...mapState('associantesAdministrativeModule', {
      fullAssociante: state => state.fullAssociante,
      comboTypesRegisterAdministrative: state => state.comboTypesRegister,
    }),
    canUpdate() {
      return this.verificarPermissao('ROLE_DEPENDENTE_ATUALIZAR')
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  async mounted() {
    this.mudarParaSocio = false
    this.registroAtual = this.fullDependent.tipoRegistro.nome
    await Promise.all([
      this.getHistoricoTipoRegistro(),
    ])
  },
  methods: {
    getHistoricoTipoRegistro() {
      this.$store
        .dispatch(
          'dependentAdministrativeModule/getHistoricoTipoRegistro',
          this.$route.params.id,
        )
        .then(response => {
          this.listaHistorico = response.data
        })
    },
    filterCombo() {
      if (this.fullDependent.tipoRegistro.id === 30) {
        return this.comboTypesRegisterAdministrative.filter(
          tipo => tipo.id === 24,
        )
      }
      return this.comboTypesRegister
    },
    inserirHistorico() {
      this.mudarParaSocio = false
      this.TipoRegistroPlace = {
        descricao: '',
        registro: {
          id: null,
        },
        tipoRegistro: {
          id: null,
        },
      }
      this.TipoRegistroPlace.registro.id = this.$route.params.id
      this.comboFiltered = this.filterCombo()
      this.disableForm = false
    },
    migrarSocio() {
      this.mudarParaSocio = true
      this.TipoRegistroPlace = {
        descricao: '',
        registro: {
          id: null,
        },
        tipoRegistro: {
          id: null,
        },
      }
      this.TipoRegistroPlace.registro.id = this.$route.params.id

      this.comboFiltered = this.comboTypesRegisterAdministrative
      this.disableForm = false
    },
    cancel() {
      this.TipoRegistroPlace = {
        descricao: '',
        registro: {
          id: null,
        },
        tipoRegistro: {
          id: null,
        },
      }
      this.disableForm = true
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.mudarParaSocio) {
            this.$store
              .dispatch(
                'dependentAdministrativeModule/migrarParaSocio',
                this.TipoRegistroPlace,
              )
              .then(response => {
                if (response) {
                  this.showMessageSuccess('Editar', 'Editado com sucesso!')
                  this.$router.push({
                    path: `/modules/administrative/phisicalPerson/editAssociante/${this.TipoRegistroPlace.registro.id}`,
                  })
                }
              })
            return
          }
          this.$store
            .dispatch(
              'dependentAdministrativeModule/setMudarTipoRegistro',
              this.TipoRegistroPlace,
            )
            .then(response => {
              this.showMessageSuccess('Editar', 'Editado com sucesso!')
              this.registroAtual = response.data.tipoRegistro.nome
              this.TipoRegistroPlace.situacaoRegistro = response.data.tipoRegistro
              this.getHistoricoTipoRegistro()
              this.disableForm = true
            })
            .catch(error => {
              const errorMsg = error.response?.data?.message || 'Falha ao Editar'
              this.MensagemError('Falha ao Editar', errorMsg)
            })
        }
      })
    },
    fieldFn(rowObj) {
      if (rowObj.dataCriacao) {
        let data = rowObj.dataCriacao.substring(0, 10)
        data = data.toLocaleString()
        return data
      }
      return rowObj
    },
  },
  data() {
    return {
      mudarParaSocio: false,
      comboFiltered: [],
      registroAtual: null,
      listaHistorico: [],
      required,
      disableForm: true,
      TipoRegistroPlace: {
        descricao: '',
        registro: {
          id: null,
        },
        situacaoRegistro: {
          id: null,
        },
      },
      columns: [
        {
          label: 'Tipo de Registro',
          field: 'tipoRegistro.nome',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Data',
          field: this.fieldFn,
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd/MM/yyyy',
        },
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc',
      },
      pageLength: 10,
      dir: false,
    }
  },
}
</script>
